// FloatingOptions.js
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Analytics from '../Images/Analytics.png'
import LearningHub from '../Images/Learning Hub.png'
import Faq from '../Images/FAQ.png'
import ContentStore from '../Images/ContentStore.png'
import * as PATH from '../CentralisedLink'
import { FaHeadset } from 'react-icons/fa';

import { Link, useLocation } from "react-router-dom";
import { useFeatureFlags } from '../FeatureFlags/FeatureFlagsContext';
import { FEATURE_FLAGS } from '../FeatureFlags/featureFlagConstants';


function FloatingOptions() {
  const [hoveredOption, setHoveredOption] = useState(null);
  const location = useLocation();
  const isDemoSupportActive = location.pathname === PATH.DEMO_SUPPORT_PATH;
  const isManagerAnalyticsActive = location.pathname === PATH.MANAGER_CONSOLE_PATH;
  const isLeadershipAnalyticsActive = location.pathname === PATH.LEADERSHIP_CONSOLE_PATH;
  const isSEAnalyticsActive = location.pathname === PATH.ANALAYTICS_PATH;

  const currentUser = useSelector(state => state.auth?.currentUser);
  const { isFeatureEnabled } = useFeatureFlags();
  const shouldShowAnalyticsNav = isFeatureEnabled(FEATURE_FLAGS.EnableAnalytics);
  const shouldShowEnablementNav = isFeatureEnabled(FEATURE_FLAGS.EnableEnablement);
  const shouldShowContentStoreNav = isFeatureEnabled(FEATURE_FLAGS.EnableContentStore);
  const shouldShowFaqNav = isFeatureEnabled(FEATURE_FLAGS.EnableFAQ);
  const shouldShowDemoSupportNav = isFeatureEnabled(FEATURE_FLAGS.EnableSupport);

  console.log(currentUser)

  const handleOptionHover = (option) => {
    setHoveredOption(option);
  };

  const handleOptionLeave = () => {
    setHoveredOption(null);
  };

  const renderNote = (option) => {
    switch (option) {
      case 'IdeaCommunity':
        return 'Idea Community';
      case 'LearningHub':
        return 'Learning Hub';
      case 'ContentStore':
        return 'Content Store';
      case 'Faq':
        return 'FAQ';
      case 'DemoSupport':
        return 'Demo Support';
      case 'ManagerConsole':
        return 'Manager Analytics';
      case 'LeadershipConsole':
        return 'Leadership Analytics';
      case 'SEAnalytics':
        return 'Your Analytics';
      default:
        return '';
    }
  };


  const roleBasedFloatingOptions = () => {
    const { typeOfUser, isManager, country } = currentUser || {};

    if (!shouldShowAnalyticsNav || country === 'Germany') {
      return null;
    }

    if (typeOfUser === 'Internal SE') {
      if (isManager) {
        // Internal SE Manager: Manager Console
        return (
          
          <Link to="/profile/manager-console" aria-label="Open Manager Analytics">
            <div
              className={`option-black ${isManagerAnalyticsActive ? 'active' : ''} ${hoveredOption === 'ManagerConsole' ? 'hovered' : ''}`}
              onMouseEnter={() => handleOptionHover('ManagerConsole')}
              onMouseLeave={handleOptionLeave}
            >
              <img src={Analytics} className="icon-float" alt="" />
              <div className={`note ${hoveredOption === 'ManagerConsole' ? 'show' : ''}`}>
                {renderNote('ManagerConsole')}
              </div>
            </div>
          </Link>
          
        );
      } else {
        // Internal SE Non-Manager: Analytics Console
        return (
          <Link to="/profile/analytics" aria-label="Open Your Analytics">
            <div
              className={`option-black ${isSEAnalyticsActive ? 'active' : ''} ${hoveredOption === 'SEAnalytics' ? 'hovered' : ''}`}
              onMouseEnter={() => handleOptionHover('SEAnalytics')}
              onMouseLeave={handleOptionLeave}
            >
              <img src={Analytics} className="icon-float" alt="" />
              <div className={`note ${hoveredOption === 'SEAnalytics' ? 'show' : ''}`}>
                {renderNote('SEAnalytics')}
              </div>
            </div>
          </Link>
        );
      }
    } else if (typeOfUser === 'Leadership') {
      // Leadership Non-Manager: Leadership Console
      return (
        <Link to="/profile/leadership-console" aria-label="Open Leadership Analytics">
          <div
            className={`option-black ${isLeadershipAnalyticsActive ? 'active' : ''} ${hoveredOption === 'LeadershipConsole' ? 'hovered' : ''}`}
            onMouseEnter={() => handleOptionHover('LeadershipConsole')}
            onMouseLeave={handleOptionLeave}
          >
            <img src={Analytics} className="icon-float" alt="" />
            <div className={`note ${hoveredOption === 'LeadershipConsole' ? 'show' : ''}`}>
              {renderNote('LeadershipConsole')}
            </div>
          </div>
        </Link>
      );
    } else if (typeOfUser === 'Admin') {
      if (isManager) {
        // Admin Manager: Manager Console
        return (
          <Link to="/profile/manager-console" aria-label="Open Manager Analytics">
            <div
              className={`option-black ${isManagerAnalyticsActive ? 'active' : ''} ${hoveredOption === 'ManagerConsole' ? 'hovered' : ''}`}
              onMouseEnter={() => handleOptionHover('ManagerConsole')}
              onMouseLeave={handleOptionLeave}
            >
              <img src={Analytics} className="icon-float" alt="" />
              <div className={`note ${hoveredOption === 'ManagerConsole' ? 'show' : ''}`}>
                {renderNote('ManagerConsole')}
              </div>
            </div>
          </Link>
        );
      } else {
        // Admin Non-Manager: Analytics Console
        return (
          <Link to="/profile/analytics" aria-label="Open Your Analytics">
            <div
              className={`option-black ${isSEAnalyticsActive ? 'active' : ''} ${hoveredOption === 'SEAnalytics' ? 'hovered' : ''}`}
              onMouseEnter={() => handleOptionHover('SEAnalytics')}
              onMouseLeave={handleOptionLeave}
            >
              <img src={Analytics} className="icon-float" alt="" />
              <div className={`note ${hoveredOption === 'SEAnalytics' ? 'show' : ''}`}>
                {renderNote('SEAnalytics')}
              </div>
            </div>
          </Link>
        );
      }
    }
    return null; // Default: No role-specific floating option
  };










  return (
    <div className="floating-options">


      {/* Idea Community */}
      {/* <Link to='/dash/idea-community'>
      <div
        className={`option ${hoveredOption === 'IdeaCommunity' ? 'hovered' : ''}`}
        onMouseEnter={() => handleOptionHover('IdeaCommunity')}
        onMouseLeave={handleOptionLeave}
      >
        <img src={Community} className='icon-float'/>
        <div className={`note ${hoveredOption === 'IdeaCommunity' ? 'show' : ''}`}>{renderNote('IdeaCommunity')}</div>
      </div>
      </Link> */}


      {shouldShowEnablementNav && (
        <Link to={`${PATH.LEARNING_HUB_PATH}`} aria-label="Open Learning Hub">
          <div
            className={`option-black ${hoveredOption === 'LearningHub' ? 'hovered' : ''}`}
            onMouseEnter={() => handleOptionHover('LearningHub')}
            onMouseLeave={handleOptionLeave}
          >
            <img src={LearningHub} className='icon-float' alt="" />
            <div className={`note ${hoveredOption === 'LearningHub' ? 'show' : ''}`}>{renderNote('LearningHub')}</div>
          </div>
        </Link>
      )}

      {shouldShowContentStoreNav && (
        <Link to={`${PATH.CONTENT_STORE_PATH}`} aria-label="Open Content Store">
          <div
            className={`option ${hoveredOption === 'ContentStore' ? 'hovered' : ''}`}
            onMouseEnter={() => handleOptionHover('ContentStore')}
            onMouseLeave={handleOptionLeave}
          >
            <img src={ContentStore} className='icon-float' alt="" />
            <div className={`note ${hoveredOption === 'ContentStore' ? 'show' : ''}`}>{renderNote('ContentStore')}</div>
          </div>
        </Link>
      )}

      {shouldShowFaqNav && (
        <Link to={`${PATH.FAQ_PATH}`} aria-label="Open FAQ">
          <div
            className={`option-black ${hoveredOption === 'Faq' ? 'hovered' : ''}`}
            onMouseEnter={() => handleOptionHover('Faq')}
            onMouseLeave={handleOptionLeave}
          >
            <img src={Faq} className='icon-float' alt="" />
            <div className={`note ${hoveredOption === 'Faq' ? 'show' : ''}`}>{renderNote('Faq')}</div>
          </div>
        </Link>
      )}

      {shouldShowDemoSupportNav && (
        <Link to={PATH.DEMO_SUPPORT_PATH} aria-label="Open Demo Support">
          <div
            className={`option ${isDemoSupportActive ? 'active' : ''} ${hoveredOption === 'DemoSupport' ? 'hovered' : ''}`}
            onMouseEnter={() => handleOptionHover('DemoSupport')}
            onMouseLeave={handleOptionLeave}
            onFocus={() => handleOptionHover('DemoSupport')}
            onBlur={handleOptionLeave}
          >
            <FaHeadset className="icon-float icon-float-react" aria-hidden="true" />
            <div className={`note ${hoveredOption === 'DemoSupport' ? 'show' : ''}`}>
              {renderNote('DemoSupport')}
            </div>
          </div>
        </Link>
      )}


    
       {/* Role-Based Options */}
       {roleBasedFloatingOptions()}



    </div>
  );
}

export default FloatingOptions;
